import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { systemItems } from "../../data/offer";
import { MOCKUP_IMAGE } from "../../data/links";
export function Hero() {
  return <header className="bg-navy-950 text-white" data-id="element-275" data-mp="cv34dxipuggd">
      <div className="bg-gold px-4 py-2.5 text-center font-display text-base font-extrabold uppercase tracking-wide text-navy-950 sm:text-lg" data-id="element-276" data-mp="huxtpwmuexzb">
        The complete Alopecia Clinical Blueprint™ is here
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-14 pt-8 sm:px-6 lg:pt-14" data-id="element-277" data-mp="qv42543op7rm">
        <p className="text-center text-sm font-semibold uppercase tracking-[0.12em] text-brand-light lg:text-left" data-id="element-278" data-mp="qt9j5vbz3pq6">
          By Dr. Daniel Mitchell · Hair Loss &amp; Scalp Health Education
        </p>

        <div className="mt-6 grid items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-279" data-mp="15kiduiuqg1a6">
          <div className="text-center lg:text-left" data-id="element-280" data-mp="15ip5mz4h1902">
            <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-gold sm:text-3xl" data-id="element-281" data-mp="1akehui3fjspq">
              Alopecia Clinical Blueprint™
            </p>
            <h1 className="mt-3 font-display text-[2.6rem] font-extrabold uppercase leading-[0.98] sm:text-6xl lg:text-[4.2rem]" data-id="element-282" data-mp="4o6n3pnv7593">
              Structure your next hair loss assessment in{" "}
              <span className="text-brand-light" data-id="element-283" data-mp="3rtp7w8ll50un">just 15 minutes</span> — with a step-by-step
              clinical roadmap.
            </h1>
            <p className="mt-5 text-lg leading-relaxed text-white/85" data-id="element-284" data-mp="sczd75ht2ivs">
              Stop jumping between scattered references, second-guessing clinical patterns, and
              struggling to organize differential diagnosis considerations.
            </p>
          </div>

          <img src={MOCKUP_IMAGE} alt="Alopecia Clinical Blueprint collection: 6 volumes, 5 bonuses and the 15-minute assessment framework" className="w-full rounded-3xl bg-white p-2 sm:p-4" data-id="element-285" data-mp="enp35v0nm6vv" />
        </div>

        <div className="mx-auto mt-10 max-w-3xl text-center" data-id="element-286" data-mp="16bz1ud5bixry">
          <p className="text-lg leading-relaxed text-white/90" data-id="element-287" data-mp="30n8iye879qpx">
            Discover <strong className="text-white" data-id="element-288" data-mp="35ljqujexpr5i">The 15-Minute Alopecia Assessment Framework™</strong>{" "}
            — a structured educational system designed to help you organize the initial review of
            hair loss findings, compare trichoscopic observations, and identify relevant differential
            diagnosis considerations.
          </p>
          <p className="mt-4 text-lg font-semibold italic text-gold" data-id="element-289" data-mp="2hxioxtc9h8z2">
            Even if you’re currently relying on multiple textbooks, scattered clinical notes, and
            disconnected trichoscopy references.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy-800 p-5 sm:p-8" data-id="element-290" data-mp="2cvtcc99e4n8v">
          <h2 className="text-center font-display text-3xl font-extrabold uppercase" data-id="element-291" data-mp="664yrcsv6aw6">
            Your complete clinical system
          </h2>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-292" data-mp="b3oqnfihim6l">
            {systemItems.map(item => <li key={item} className="flex items-start gap-3 text-base font-semibold leading-snug" data-id="element-293" data-mp="1vnk18ouzzf1x">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-294" data-mp="1qpikial1nrtm" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-295" data-mp="20ltzx9fxkxsa">
            <p className="font-display text-xl font-bold uppercase tracking-wide text-white/80" data-id="element-296" data-mp="20k0pdj275tf0">
              Get the complete system today
            </p>
            <p className="mt-1 font-display text-6xl font-extrabold uppercase text-gold" data-id="element-297" data-mp="2aavd6rv3d12k">
              Just $27 <span className="text-3xl" data-id="element-298" data-mp="2oamy7ck0zhq2">USD</span>
            </p>
          </div>

          <CTAButton id="hero-cta" className="mt-6" tone="dark" label="Yes! I want the Alopecia Clinical Blueprint™" note="Digital product · One-time payment · No recurring subscription" data-id="element-299" data-mp="2jc36evir3bps" />
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-white/55" data-id="element-300" data-mp="qfr97jnjvxsq">
          The 15-minute framework is designed for organizing an initial review of available clinical
          information. It is not a time limit or guarantee for completing a patient diagnosis.
        </p>
      </div>
    </header>;
}